export const developerConstants = {
    DEVELOPER_CHANGE_VALUE: "DEVELOPER_CHANGE_VALUE",

    // Developer stats
    GET_DEVELOPER_STATS_STARTED: "GET_DEVELOPER_STATS_STARTED",
    GET_DEVELOPER_STATS_SUCCESS: "GET_DEVELOPER_STATS_SUCCESS",
    GET_DEVELOPER_STATS_FAILURE: "GET_DEVELOPER_STATS_FAILURE",

    // Developer profile
    GET_DEVELOPER_PROFILE_STARTED: "GET_DEVELOPER_PROFILE_STARTED",
    GET_DEVELOPER_PROFILE_SUCCESS: "GET_DEVELOPER_PROFILE_SUCCESS",
    GET_DEVELOPER_PROFILE_FAILURE: "GET_DEVELOPER_PROFILE_FAILURE",

    UPDATE_DEVELOPER_PROFILE_STARTED: "UPDATE_DEVELOPER_PROFILE_STARTED",
    UPDATE_DEVELOPER_PROFILE_SUCCESS: "UPDATE_DEVELOPER_PROFILE_SUCCESS",
    UPDATE_DEVELOPER_PROFILE_FAILURE: "UPDATE_DEVELOPER_PROFILE_FAILURE",

    // Published apps stats
    GET_PUBLISHED_APPS_STATS_STARTED: "GET_PUBLISHED_APPS_STATS_STARTED",
    GET_PUBLISHED_APPS_STATS_SUCCESS: "GET_PUBLISHED_APPS_STATS_SUCCESS",
    GET_PUBLISHED_APPS_STATS_FAILURE: "GET_PUBLISHED_APPS_STATS_FAILURE",

    // App analytics
    GET_APP_ANALYTICS_STARTED: "GET_APP_ANALYTICS_STARTED",
    GET_APP_ANALYTICS_SUCCESS: "GET_APP_ANALYTICS_SUCCESS",
    GET_APP_ANALYTICS_FAILURE: "GET_APP_ANALYTICS_FAILURE",

    // Revenue stats
    GET_REVENUE_STATS_STARTED: "GET_REVENUE_STATS_STARTED",
    GET_REVENUE_STATS_SUCCESS: "GET_REVENUE_STATS_SUCCESS",
    GET_REVENUE_STATS_FAILURE: "GET_REVENUE_STATS_FAILURE"
};